<template>
  <section class="section section-white">
    <div class="container text-center fade-in-section">
      <h2 class="section-title">Ready to Build Your QA Legacy?</h2>
      <p class="section-subtitle max-w-3xl">Join <strong>500+</strong> QA professionals already on the waitlist. Your future self will thank you.</p>
      
      <button @click="scrollToTop" class="final-cta-btn">Secure Your Spot Now</button>
      
      <p class="cta-note">No credit card required • Cancel anytime • Early bird discount</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FinalCTASection',
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
</script>
